export default "/img/CG.1771760e29e4ca831e04f3872ec1e21a.png";